<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.unit_of_measurement.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus mr-1"></span> NOVO
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createUnitOfMeasurement" hide-footer>
          <template v-slot:modal-title>NOVA UNIDADE DE MEDIDA</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="NOME" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12">
                    <LabelRequiredField label="ABREVIAÇÃO" />
                    <input
                      type="text"
                      v-model="abbreviation"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check mr-1"></span>
                      {{ loadingCreate ? "CARREGANDO" : "SALVAR" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            UNIDADES DE MEDIDA
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="unitOfMeasurements"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal update UnitOfMeasurement -->
              <b-modal :id="`unitOfMeasurement_${String(item.id)}`" hide-footer>
                <template v-slot:modal-title>EDITAR UNIDADE DE MEDIDA</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay
                      :show="loadingUnitOfMeasurementUpdate"
                      opacity="0.99"
                    >
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="NOME" />
                            <input
                              :disabled="!permissions.unit_of_measurement.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <LabelRequiredField label="ABREVIAÇÃO" />
                            <input
                              :disabled="!permissions.unit_of_measurement.edit"
                              type="text"
                              v-model="abbreviation"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="
                                $bvModal.hide(
                                  `unitOfMeasurement_${String(item.id)}`
                                )
                              "
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.unit_of_measurement.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success"
                            >
                              <span class="fa fa-check mr-1"></span>
                              {{ loadingUpdate ? "CARREGANDO" : "SALVAR" }}
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal update UnitOfMeasurement -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "UnitOfMeasurement",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "CÓDIGO", sortable: false, value: "id" },
        { text: "NOME", value: "name" },
        { text: "ABREVIAÇÃO", value: "abbreviation" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      unitOfMeasurements: [],
      id: "",
      name: "",
      abbreviation: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingUnitOfMeasurementUpdate: false,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.get(item.id);
      this.$bvModal.show(`unitOfMeasurement_${String(item.id)}`);
    },
    retrieve() {
      this.permissions = adminData().permissions;

      this.paginate();
    },
    async paginate() {
      try {
        this.loading = true;

        const response = await api.get("/admin/unit-of-measurement/paginate");

        const { unit_of_measurement } = response.data;

        this.unitOfMeasurements = unit_of_measurement;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name, abbreviation } = this;

        let params = { name, abbreviation };

        const response = await api.post(
          "/admin/unit-of-measurement/create",
          params
        );

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createUnitOfMeasurement");
          this.errors = [];
          this.paginate();
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.abbreviation = "";
      this.$bvModal.show("createUnitOfMeasurement");
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name, abbreviation } = this;

        let params = { id, name, abbreviation };

        const response = await api.put(
          "/admin/unit-of-measurement/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`unitOfMeasurement_${String(id)}`);
          this.errors = [];
          this.paginate();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async get(id) {
      try {
        this.loadingUnitOfMeasurementUpdate = true;

        this.id = id;

        const response = await api.get("/admin/unit-of-measurement/get", {
          params: { id },
        });

        const { unit_of_measurement } = response.data;

        this.id = unit_of_measurement.id;
        this.name = unit_of_measurement.name;
        this.abbreviation = unit_of_measurement.abbreviation;
        this.loadingUnitOfMeasurementUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>